import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/api";

export const getRoles = createAsyncThunk(
  "role/getRole",
  async (search = '', { rejectWithValue }) => {
    try {
      const response = await api.get("admin/roles?search=" + search);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { status: "error", message: "Failed to get roles" }
      );
    }
  }
);

export const getRolePermissions = createAsyncThunk(
  "role/getRolePermissions",
  async (id = '', { rejectWithValue }) => {
    try {
      const response = await api.get("admin/roles/" + id);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { status: "error", message: "Failed to get role permissions" }
      );
    }
  }
);


export const addRole = createAsyncThunk(
  "role/addRole",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post("admin/roles", formData);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { status: "error", message: "Failed to add role" }
      );
    }
  }
);

export const updateRolePermissions = createAsyncThunk(
  "role/updateRolePermissions",
  async ({roleId, permissions}, { rejectWithValue }) => {
    try {
      permissions._method = "PUT";
      const response = await api.post("admin/roles/"+roleId, permissions);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { status: "error", message: "Failed to add role" }
      );
    }
  }
);

const roleSlice = createSlice({
  name: "role",
  initialState: {
    list_roles: [],
    list_role_permissions:[],
    selected: null,
    status: "idle",
    loading: false,
    error: null,
  },
  reducers: {
    setSelectedRole(state, action) {
      const payload = action.payload || {};
      state.selected = {
        id: payload.id || "",
        role_name: payload.role_name || "",
        permissions: payload.permissions || "",
      };
    },
    unsetSelectedRole(state) {
      state.selected = null;
    },
    resetStatus(state) {
      state.status = "idle";
      state.error = null;
      state.message = null;
    },
    togglePermission: (state, action) => {
      const { permission_name } = action.payload;

      Object.values(state.list_role_permissions.data.permissions || {}).forEach((perms) => {
        const perm = perms.find((p) => p.name === permission_name);
        if (perm) perm.is_check = perm.is_check === "yes" ? "no" : "yes";
      });
    }



  },
  extraReducers: (builder) => {
    builder
      .addCase(getRoles.pending, (state) => {
          state.status = "loading";
          state.loading = true;
      })
      .addCase(getRoles.fulfilled, (state, action) => {
          state.list_roles = action.payload;
          state.loading = false;
      })
      .addCase(getRoles.rejected, (state, action) => {
          state.status = "error";
          state.loading = false;
      })
      .addCase(addRole.pending, (state) => {
          state.status = "loading";
          state.loading = true;
      })
      .addCase(addRole.fulfilled, (state, action) => {
          state.loading = false;
      })
      .addCase(addRole.rejected, (state, action) => {
          state.status = "error";
          state.loading = false;
      })
      .addCase(getRolePermissions.pending, (state) => {
          state.status = "loading";
          state.loading = true;
      })
      .addCase(getRolePermissions.fulfilled, (state, action) => {
          state.list_role_permissions = action.payload;
          state.loading = false;
      })
      .addCase(getRolePermissions.rejected, (state, action) => {
          state.status = "error";
          state.loading = false;
      })
      .addCase(updateRolePermissions.pending, (state) => {
          state.status = "loading";
          state.loading = true;
      })
      .addCase(updateRolePermissions.fulfilled, (state, action) => {
          state.loading = false;
      })
      .addCase(updateRolePermissions.rejected, (state, action) => {
          state.status = "error";
          state.loading = false;
      })
    }
});

export const { setSelectedRole, unsetSelectedRole, resetStatus, togglePermission } = roleSlice.actions;
export default roleSlice.reducer;
